
import { searchEntities } from '../../store/selectors/search';

export const selectSuiteAreas = state => searchEntities(state, 'suiteAreas', []);
